import React, { useState } from 'react'

import Container from 'components/atoms/Container'
import SectionContainer from 'components/atoms/SectionContainer'
import Typography from 'components/atoms/Typography'
import MajorAccordion from 'components/molecules/MajorAccordion'

import majorData from './majorData.json'

const PintariaMajor = () => {
  const initialState = () => majorData.map((major, idx) => ({
    ...major,
    active: idx === 0,
    id: idx,
  }))
  const [majors, setmajors] = useState(initialState())

  const togglePrograms = (id) => {
    const newmajors = majors.map(major => (
        major.id === id ? { ...major, active: !major.active } : { ...major, active: false }
      )
    )
    setmajors(newmajors)
  }
  return (
    // ignore this section, since the UI still on discuss
    <div className="pintaria-major">
      <SectionContainer
        paddingTop={80}
        paddingBottom={120}
        marginTop={80}
      >
        <Container>
          <Typography component="h2" variant="title" className="text-variant-title-sm text-center">
            Jurusan
          </Typography>
          <div className="pintaria-major__wrapper">
            {
              majors.map(major => (
                <MajorAccordion
                  major={major.major}
                  programs={major.programs}
                  active={major.active}
                  key={`pintaria-major-itm-${major.id}`}
                  onClick={() => togglePrograms(major.id)}
                />
              ))
            }
          </div>
        </Container>
      </SectionContainer>
      <style jsx>
        {`
            .pintaria-major {
              &__wrapper {
                display: flex;
                @media screen and (max-width: 767px) {
                  flex-direction: column;
                }
                @media screen and (min-width: 768px) {
                  flex-wrap: wrap;
                }
              }
            }
        `}
      </style>
    </div>
  )
}


export default PintariaMajor
